import LeftSideComponent from "../components/leftSideComponent";
import { useWindowWidthAndHeight } from "../../../shared/hooks/customHooks";
import NavBar from "./navBar";
import SmallScreenBurgerMenu from "./smallScreenBurgerMenu";
import LangageSwitcher from "../components/langageSwitcher";
import "./headerStyle.css";

const HeaderWrapper = () => {
  const [width] = useWindowWidthAndHeight();
  return (
    <header role="banner">
      {width > 1150 ? (
        <div className="header-container">
          <LeftSideComponent />
          <NavBar />
          <div className="lng-container">
            <LangageSwitcher></LangageSwitcher>
          </div>
        </div>
      ) : (
        <div className="small-header-container">
          <div className="small-header">
            <div className="small-header-left-container">
              <LeftSideComponent />
              <div className="lng-container">
                <LangageSwitcher></LangageSwitcher>
              </div>
            </div>
            <div className="right-side-container">
              <SmallScreenBurgerMenu />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default HeaderWrapper;
